document.addEventListener('DOMContentLoaded', initScripts);

function initScripts() {

    //initScentSwitcher();

    initMoreScents();
}

function initScentSwitcher() {
    const scents = document.querySelectorAll('.js-product-links-item');

    scents.forEach((scent) => {
        scent.addEventListener('click', (event) => {
            event.preventDefault();
            const activeScent = document.querySelector('.js-product-links-item.active');

            if (event.target !== activeScent) {
               switchScents(event.target);
            }
        });
    });
}

function switchScents(selectedScent) {
    const url = selectedScent.getAttribute('data-href');
    const sectionId = selectedScent.getAttribute('data-section-id');

    selectedScent.classList.add('loader');
    selectedScent.removeAttribute('data-hidden');

    const newColor = selectedScent.getAttribute('data-color');

    fetch(url)
        .then(res => res.text())
        .then(data => {

            try {

                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');

                // Replace Main Section
                const newMainSection = doc.querySelector(`#${sectionId}`);
                const currentMainSection = document.querySelector(`#${sectionId}`);
                const currentProductId = document.querySelector('.product-links')?.getAttribute('data-product-id');
                if (newMainSection && currentMainSection) {

                    currentMainSection.querySelector(`.product-information__media`)?.replaceWith(newMainSection.querySelector(`.product-information__media`));
                    currentMainSection.querySelector(`[data-type="header"]`)?.replaceWith(newMainSection.querySelector(`[data-type="header"]`));
                    currentMainSection.querySelector(`.product-title`)?.replaceWith(newMainSection.querySelector(`.product-title`));
                    currentMainSection.querySelector(`.product-content`)?.replaceWith(newMainSection.querySelector(`.product-content`));
                    currentMainSection.querySelector(`variant-picker`)?.replaceWith(newMainSection.querySelector(`variant-picker`));
                    //currentMainSection.querySelector(`.gpo-container`)?.replaceWith(newMainSection.querySelector(`.gpo-container`));
                    currentMainSection.querySelector(`.buy-buttons-block`)?.replaceWith(newMainSection.querySelector(`.buy-buttons-block`));
                    currentMainSection.querySelector(`accordion-custom`)?.replaceWith(newMainSection.querySelector(`accordion-custom`));

                }

                // Update URL without reload
                window.history.replaceState({}, '', url);

                selectedScent.classList.remove('loader');

                document.querySelectorAll('.js-product-links-item')?.forEach(scent => {
                    if(scent.getAttribute('href') === selectedScent.getAttribute('href')) {
                        scent.classList.add('active');
                        scent.removeAttribute('data-hidden');
                    } else {
                        scent.classList.remove('active');
                    }
                })

            } catch (err) {
                console.error('Processing error:', err);
                window.location.href = url;
            }
        }).catch(err => {
            console.error('Fetch failed:', err);
            window.location.href = url;
        });
}



function initMoreScents() {
    const productScents = document.querySelectorAll('.js-product-links-item');
    const showMoreBtn = document.querySelector('.js-product-links-btn');
    let visibleActiveScent = false;

    productScents.forEach((scent, index) => {
        if (scent.classList.contains('active') && scent.classList.contains('first')) {
            visibleActiveScent = true;
        }
    });

    if (!visibleActiveScent) {
        toggleScents(productScents, showMoreBtn, 'open');
    }

    showMoreBtn.addEventListener('click', () => {
        if (showMoreBtn.dataset.close === 'false') {
            toggleScents(productScents, showMoreBtn, 'open');
        } else {
            toggleScents(productScents, showMoreBtn, 'close');
        }
    });

    // Stop unnecessary navigation
    productScents.forEach((scentPill) => {
        scentPill.addEventListener('click', (e) => {
            if (scentPill.classList.contains('active')) {
                e.preventDefault();
                return false;
            }
        });
    });
}

function toggleScents(scents, toggleButton, operation) {
    if (operation === 'open') {
        scents.forEach((scent) => {
            scent.classList.remove('hidden');
            toggleButton.textContent = 'Close';
            toggleButton.dataset.close = 'true';
        });
    } else {
        scents.forEach((scent, index) => {
            if (scent.dataset.hidden === 'true') {
                scent.classList.add('hidden');
                toggleButton.textContent = toggleButton.dataset.text;
                toggleButton.dataset.close = 'false';
            }

            if(scent.classList.contains('active')) {
                scent.classList.add('first');
            } else {
                scent.classList.remove('first');
            }

            updateScentsVisibility();

        });
    }
}

function updateScentsVisibility() {
    const productScents = document.querySelectorAll('.js-product-links-item');
    const visiblePills = +document.querySelector('.js-pills').getAttribute('data-visible-pills');

    productScents.forEach((scent, index) => {
        if(index >= visiblePills) {
            if(!scent.classList.contains('active')) {
                scent.setAttribute('data-hidden', 'true');
                scent.classList.add('hidden');
            }
        } else {
            scent.removeAttribute('data-hidden');
            scent.classList.remove('hidden');
        }
    })
}
